// services/tax.js
import axiosInstance from './axiosInstance';

const TAX_API_URL = '/tax';

const taxService = {
  async get() {
    try {
      const response = await axiosInstance.get(`${TAX_API_URL}/get.php`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  }
};

export default taxService;
